export const ProductTagGroupPreferenceEndpoints = {
    list: '/preferences/product-tag-group/list',
    listTag: '/preferences/product-tag-group/list/tag',
    add: '/preferences/product-tag-group/add',
    edit: (id: string) => `/preferences/product-tag-group/edit/${id}`,
    remove: (id: string) => `/preferences/product-tag-group/del/${id}`,
    info: (id: string) => `/preferences/product-tag-group/${id}`,
    toggle: (id: string) => `/preferences/product-tag-group/status/${id}`,
}
